import { cn } from '../lib/cn.js'

export function KanbanColumn({
  titulo, quantidade, tom = 'neutro', children, className,
}: {
  titulo: string
  quantidade: number
  tom?: 'novo' | 'ativo' | 'pronto' | 'neutro' | undefined
  children: React.ReactNode
  className?: string | undefined
}) {
  return (
    <section className={cn('du-coluna', `du-coluna--${tom}`, className)} aria-label={`${titulo}, ${quantidade} pedidos`}>
      <header className="du-coluna__topo">
        <h3 className="du-coluna__titulo">{titulo}</h3>
        <span className="du-coluna__contador">{quantidade}</span>
      </header>
      <div className="du-coluna__lista">{children}</div>
    </section>
  )
}
